import { useEffect, useState } from 'react';

import { useKeyPress } from 'hooks/useKeyPress';

/**
 * Provides logic often used when opening
 * closing and ESC closing modals.
 */
export const useModalState = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isESCPressed = useKeyPress(['Escape']);

  useEffect(() => {
    if (isESCPressed) {
      setIsModalOpen(false);
    }
  }, [isESCPressed]);

  useEffect(() => {
    const html = document.getElementsByTagName('html')[0];
    if (isModalOpen) {
      html.classList.add('overflow-y-hidden');
    } else {
      html.classList.remove('overflow-y-hidden');
    }
  }, [isModalOpen]);

  return {
    isModalOpen,
    openModal: () => setIsModalOpen(true),
    closeModal: () => setIsModalOpen(false),
  };
};
